// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3rT0g","title":"Info_title__3ZU85","selects":"Info_selects__1hFdj","requiredAsterisk":"Info_requiredAsterisk__yR7_L"};